// FAQ Section – JS extracted for caching; supports editor & live
(function () {
  function setPanelHeight(item, open) {
    const answer = item.querySelector('.faq-answer');
    if (!answer) return;
    if (open) {
      // measure natural height
      answer.style.height = 'auto';
      const h = answer.scrollHeight;
      answer.style.height = '0px';
      requestAnimationFrame(() => {
        answer.style.height = (h + 40) + 'px';
      });
    } else {
      answer.style.height = answer.scrollHeight + 'px';
      requestAnimationFrame(() => {
        answer.style.height = '0px';
      });
    }
  }

  function toggleItem(item, forceOpen = null) {
    const isActive = item.classList.contains('active');
    const willOpen = forceOpen === null ? !isActive : forceOpen;

    // close siblings in same panel
    item.parentElement.querySelectorAll('.faq-item').forEach(sib => {
      if (sib !== item && sib.classList.contains('active')) {
        sib.classList.remove('active');
        setPanelHeight(sib, false);
        const btn = sib.querySelector('.faq-question');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });

    item.classList.toggle('active', willOpen);
    setPanelHeight(item, willOpen);
    const btn = item.querySelector('.faq-question');
    if (btn) btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

    // optional: deep-link exact question
    if (willOpen && item.id) {
      history.replaceState(null, '', '#' + item.id);
    }
  }

  function setActiveTab(root, tab) {
    const tabs = root.querySelectorAll('[role="tab"]');
    const panels = root.querySelectorAll('[role="tabpanel"]');

    tabs.forEach(t => {
      const selected = t === tab;
      t.classList.toggle('active', selected);
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    panels.forEach(p => p.hidden = (p.id !== tab.getAttribute('aria-controls')));

    // collapse all accordions
    root.querySelectorAll('.faq-item').forEach(item => {
      item.classList.remove('active');
      const ans = item.querySelector('.faq-answer');
      if (ans) ans.style.height = '0px';
      const btn = item.querySelector('.faq-question');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });

    // open first item in panel
    const firstItem = root.querySelector('#' + tab.getAttribute('aria-controls') + ' .faq-item');
    if (firstItem) toggleItem(firstItem, true);

    // update hash to category
    history.replaceState(null, '', '#' + tab.dataset.category);
  }

  function initFAQ(root) {
    if (!root || root.__faqInit) return;
    root.__faqInit = true;

    const tabs = root.querySelectorAll('[role="tab"]');
    const panels = root.querySelectorAll('[role="tabpanel"]');

    // Tab clicks
    tabs.forEach(tab => tab.addEventListener('click', () => setActiveTab(root, tab)));

    // Keyboard navigation (vertical tabs)
    root.addEventListener('keydown', (e) => {
      if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(e.key)) return;
      const t = Array.from(tabs);
      const activeIndex = t.findIndex(x => x.getAttribute('aria-selected') === 'true');
      let next = activeIndex;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (activeIndex + 1) % t.length;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (activeIndex - 1 + t.length) % t.length;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = t.length - 1;
      t[next].focus();
      setActiveTab(root, t[next]);
      e.preventDefault();
    });

    // Accordion clicks
    root.querySelectorAll('.faq-item .faq-question').forEach(btn => {
      btn.addEventListener('click', () => toggleItem(btn.closest('.faq-item')));
    });

    // Initial state: hash category or first tab
    const hash = location.hash.replace('#', '');
    const hashTab = Array.from(tabs).find(t => t.dataset.category === hash);
    setActiveTab(root, hashTab || tabs[0]);

    // If hash points to a specific item, open it after tab init
    if (hash) {
      const deepItem = root.querySelector('#' + hash);
      if (deepItem && deepItem.classList.contains('faq-item')) {
        // ensure correct tab is active
        const panel = deepItem.closest('[role="tabpanel"]');
        if (panel) {
          const tab = root.querySelector('[aria-controls="' + panel.id + '"]');
          if (tab) setActiveTab(root, tab);
        }
        toggleItem(deepItem, true);
        deepItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    // Transition end cleanup (so height:auto can work after animation)
    root.querySelectorAll('.faq-answer').forEach(ans => {
      ans.addEventListener('transitionend', (evt) => {
        if (evt.propertyName !== 'height') return;
        const open = ans.closest('.faq-item')?.classList.contains('active');
        if (open) ans.style.height = 'auto';
      });
    });
  }

  // Live + Theme Editor support
  function boot(container) {
    container.querySelectorAll('.faq-section').forEach(initFAQ);
  }

  document.addEventListener('DOMContentLoaded', () => boot(document));
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
